import { render, staticRenderFns } from "./SelectButtons.vue?vue&type=template&id=33567cea&scoped=true&"
import script from "./SelectButtons.vue?vue&type=script&lang=js&"
export * from "./SelectButtons.vue?vue&type=script&lang=js&"
import style0 from "./SelectButtons.vue?vue&type=style&index=0&id=33567cea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33567cea",
  null
  
)

export default component.exports